/**
 * How a connection reads on screen, as an execution state with its own words: checking (running),
 * connected (done), rejected by the app (failed), or saved but never checked (queued).
 */
const resolveConnectionState = ({ connection, isChecking = false }) => {
  if (isChecking) {
    return { state: 'running', label: 'Checking' };
  }

  if (connection?.status === 'valid') {
    return { state: 'done', label: 'Connected' };
  }

  if (connection?.status === 'invalid') {
    return { state: 'failed', label: 'Not working' };
  }

  return { state: 'queued', label: 'Not checked' };
};

export default resolveConnectionState;
